import ToUsersEnum from '../../../../../Spirit/Admin/Interfaces/Models/NotificationService/Enums/ToUsersEnum';
import NotificationTypeEnum from '../../../../../Spirit/Entities/Enums/NotificationTypeEnum';
import PushMessageTranslationsRequest from '../../../../../Spirit/Admin/Interfaces/Models/NotificationService/PushMessageTranslationsRequest';

export default class SendCustomMessageRequest  {
	ToUsers: ToUsersEnum = null;
	Type: NotificationTypeEnum = null;
	Translatons: Array<PushMessageTranslationsRequest> = null;
	constructor(obj?: Partial<SendCustomMessageRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
